
import "./simpleBarChart.scss";

interface ISimpleBarChartComponentBindings {
    label: string;
    value: number;
}

class SimpleBarChartComponentController implements angular.IComponentController, ISimpleBarChartComponentBindings {

    label: string;
    value: number;

    static $inject = [];

    constructor() {
    }

    $onInit(): void {

    }
}

export class SimpleBarChartComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            label: "@",
            value: "<"
        };

        this.controller = SimpleBarChartComponentController;
        this.template = require("./simpleBarChart.html");
    }
}
